import { Spine } from '@esotericsoftware/spine-pixi'

export function playSpine(spine: Spine, animation: string, loop = false, timeScale = 1.0) {
  return new Promise<void>((resolve) => {
    spine.state.timeScale = timeScale 
    const track = spine.state.setAnimation(0, animation, loop)
    if (!loop) {
      const duration = (track.animation?.duration ?? 0) * (1000 / timeScale)
      setTimeout(() => {
        resolve()
      }, duration)
    }
    else {
      resolve()
    }
  })
}
